import React from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Table,
  Button,
  Form,
} from "react-bootstrap";

import styles from "./TransactionLedger.module.css";

import {
  FaWallet,
  FaCloudUploadAlt,
  FaCloudDownloadAlt,
  FaPercentage,
  FaFilter,
  FaDownload,
  FaFileAlt,
  FaChevronLeft,
  FaChevronRight,
} from "react-icons/fa";

const summaryCards = [
  {
    title: "Current Balance",
    amount: "₦2,450,000.00",
    desc: "Available Balance",
    icon: <FaWallet />,
    color: styles.greenIcon,
  },
  {
    title: "Total Deposits",
    amount: "₦3,620,000.00",
    desc: "All time deposits",
    icon: <FaCloudUploadAlt />,
    color: styles.blueIcon,
  },
  {
    title: "Total Withdrawals",
    amount: "₦1,170,000.00",
    desc: "All time withdrawals",
    icon: <FaCloudDownloadAlt />,
    color: styles.orangeIcon,
  },
  {
    title: "Interest Earned (YTD)",
    amount: "₦185,000.00",
    desc: "Year to date",
    icon: <FaPercentage />,
    color: styles.purpleIcon,
  },
];

const transactions = [
  {
    date: "01 Jul 2024, 10:30 AM",
    description: "Savings Deposit",
    reference: "DEP2407011030",
    type: "Deposit",
    amount: "+₦50,000.00",
    balance: "₦2,450,000.00",
    channel: "Mobile App",
  },
  {
    date: "25 Jun 2024, 09:15 AM",
    description: "Monthly Savings",
    reference: "MON2406250915",
    type: "Deposit",
    amount: "+₦25,000.00",
    balance: "₦2,400,000.00",
    channel: "Standing Order",
  },
  {
    date: "18 Jun 2024, 02:20 PM",
    description: "Standing Order",
    reference: "STO2406181420",
    type: "Deposit",
    amount: "+₦25,000.00",
    balance: "₦2,375,000.00",
    channel: "Standing Order",
  },
  {
    date: "10 Jun 2024, 11:05 AM",
    description: "Withdrawal",
    reference: "WDR2406101105",
    type: "Withdrawal",
    amount: "-₦100,000.00",
    balance: "₦2,350,000.00",
    channel: "Branch",
  },
  {
    date: "05 Jun 2024, 09:40 AM",
    description: "Interest Capitalized",
    reference: "INT2406050940",
    type: "Interest",
    amount: "+₦12,500.00",
    balance: "₦2,450,000.00",
    channel: "System",
  },
  {
    date: "25 May 2024, 09:12 AM",
    description: "Monthly Savings",
    reference: "MON2405250912",
    type: "Deposit",
    amount: "+₦25,000.00",
    balance: "₦2,437,500.00",
    channel: "Standing Order",
  },
  {
    date: "18 May 2024, 02:18 PM",
    description: "Standing Order",
    reference: "STO2405181418",
    type: "Deposit",
    amount: "+₦25,000.00",
    balance: "₦2,412,500.00",
    channel: "Standing Order",
  },
  {
    date: "10 May 2024, 10:45 AM",
    description: "Withdrawal",
    reference: "WDR2405101045",
    type: "Withdrawal",
    amount: "-₦80,000.00",
    balance: "₦2,387,500.00",
    channel: "ATM",
  },
  {
    date: "01 May 2024, 08:30 AM",
    description: "Savings Deposit",
    reference: "DEP2405010830",
    type: "Deposit",
    amount: "+₦40,000.00",
    balance: "₦2,467,500.00",
    channel: "Mobile App",
  },
  {
    date: "25 Apr 2024, 09:10 AM",
    description: "Monthly Savings",
    reference: "MON2404250910",
    type: "Deposit",
    amount: "+₦25,000.00",
    balance: "₦2,427,500.00",
    channel: "Standing Order",
  },
];

const TransactionLedger = () => {
  return (
    <Container fluid className={styles.wrapper}>
      {/* SUMMARY CARDS */}

      <Row className="g-4 mb-4">
        {summaryCards.map((card, index) => (
          <Col lg={3} md={6} key={index}>
            <Card className={styles.summaryCard}>
              <Card.Body>
                <Row className="align-items-center">
                  <Col xs={3}>
                    <div className={`${styles.iconBox} ${card.color}`}>
                      {card.icon}
                    </div>
                  </Col>

                  <Col xs={9}>
                    <h6>{card.title}</h6>

                    <h2>{card.amount}</h2>

                    <p>{card.desc}</p>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>

      {/* TRANSACTION SECTION */}

      <section className={styles.tableSection}>
        {/* HEADER */}

        <div className={styles.header}>
          <div>
            <h3>Transaction Ledger</h3>

            <p>View all your savings account transactions</p>
          </div>

          <div className={styles.actions}>
            <Button variant="light" className={styles.filterBtn}>
              <FaFilter />
              Filter
            </Button>

            <div className={styles.dateWrapper}>
              <Form.Control
                type="date"
                className={styles.dateInput}
              />

              <span>-</span>

              <Form.Control
                type="date"
                className={styles.dateInput}
              />
            </div>

            <Button className={styles.exportBtn}>
              <FaDownload />
              Export
            </Button>
          </div>
        </div>

        {/* TABLE */}

        <div className={styles.tableResponsive}>
          <Table hover borderless>
            <thead>
              <tr>
                <th>Date & Time</th>
                <th>Description</th>
                <th>Reference No.</th>
                <th>Type</th>
                <th>Amount</th>
                <th>Balance</th>
                <th>Channel</th>
                <th>Receipt</th>
              </tr>
            </thead>

            <tbody>
              {transactions.map((item, index) => (
                <tr key={index}>
                  <td>{item.date}</td>

                  <td>{item.description}</td>

                  <td>{item.reference}</td>

                  <td>
                    <span
                      className={
                        item.type === "Deposit"
                          ? styles.deposit
                          : item.type === "Withdrawal"
                          ? styles.withdrawal
                          : styles.interest
                      }
                    >
                      {item.type}
                    </span>
                  </td>

                  <td
                    className={
                      item.amount.startsWith("+")
                        ? styles.credit
                        : styles.debit
                    }
                  >
                    {item.amount}
                  </td>

                  <td>{item.balance}</td>

                  <td>
                    <span className={styles.channel}>
                      {item.channel}
                    </span>
                  </td>

                  <td className={styles.receipt}>
                    <FaFileAlt />
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>

        {/* FOOTER */}

        <div className={styles.footer}>
          <p>Showing 1 to 10 of 45 transactions</p>

          <div className={styles.paginationSection}>
            <button className={styles.navBtn}>
              <FaChevronLeft />
            </button>

            <button className={`${styles.pageBtn} ${styles.active}`}>
              1
            </button>

            <button className={styles.pageBtn}>2</button>

            <button className={styles.pageBtn}>3</button>

            <button className={styles.pageBtn}>4</button>

            <button className={styles.pageBtn}>5</button>

            <button className={styles.navBtn}>
              <FaChevronRight />
            </button>

            <select className={styles.pageSelect}>
              <option>10 / page</option>
            </select>
          </div>
        </div>
      </section>
    </Container>
  );
};

export default TransactionLedger;